const swap = (a,i,j)=>{
  const t = a[i];
  a[i] = a[j];
  a[j] = t;
}

export default swap;


// WEBPACK FOOTER //
// ./src/utils/swap.js